
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqnBGt9HPnYBERRaBQJGFYmysZe5BRtayLa2y6FWbnAMUMeta } from "/codebuild/output/src2781717372/src/src/pages/faq.vue?macro=true";
import { default as menueKJ_459xPHB6JaXRjJPOoYu46lEXGuzRK8lde6jnrNxGAMeta } from "/codebuild/output/src2781717372/src/src/pages/menu.vue?macro=true";
import { default as indexTKhq3FpZ7KcEMu1Lsxfkx6e6OKOglfxxAuEWlwP6HvYMeta } from "/codebuild/output/src2781717372/src/src/pages/index.vue?macro=true";
import { default as contact9vBinwuXIYfKEdnGz_hWiDh1UEBYKK1LUuJEA29kznIMeta } from "/codebuild/output/src2781717372/src/src/pages/contact.vue?macro=true";
import { default as tutorialH6Po0HYR1c7EMxpRCRGz2FNOEitYDMXOKzTzL_45pn4P8Meta } from "/codebuild/output/src2781717372/src/src/pages/tutorial.vue?macro=true";
import { default as agreementb4hp0M5_GR97DYIkjay34G1_wtwYW9uaqX5ATYHzwboMeta } from "/codebuild/output/src2781717372/src/src/pages/agreement.vue?macro=true";
import { default as about_45passlVqR1OuCC0eer0CrjFCd9Dskgf0I0m4DPOiNGrbF7vAMeta } from "/codebuild/output/src2781717372/src/src/pages/about-pass.vue?macro=true";
import { default as indexeS04ZrMMbfg0lda6X_5n882kzyM1_Oc2wB8Yj4GoLaEMeta } from "/codebuild/output/src2781717372/src/src/pages/card/index.vue?macro=true";
import { default as _91id_930Q4AF24VTS7UJrxJvkc_yCkPFhokJROuelwigpQHM1oMeta } from "/codebuild/output/src2781717372/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancePRug9x7_45s_4CsWnHecvONIOayFq9mTnRg3CDXKopCmQMeta } from "/codebuild/output/src2781717372/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93HMeUAVHF2xXwZJ6u15s9Ysw9GZvjq1FRm9jbaJvK2e4Meta } from "/codebuild/output/src2781717372/src/src/pages/notice/[id].vue?macro=true";
import { default as indexL3n4SxzwGR4pQiEUacw1PQJ270BzeQfTEsjJdU66AKEMeta } from "/codebuild/output/src2781717372/src/src/pages/coupon/index.vue?macro=true";
import { default as indexGb20yqMq9EZR5_7VVWe35qD5rE_nlCrC7Pd2ox_WD90Meta } from "/codebuild/output/src2781717372/src/src/pages/mypage/index.vue?macro=true";
import { default as indexPaQ2tpVGw8L0aN78fS5_GXP_45kWZuVMyT3W52g_3vmx0Meta } from "/codebuild/output/src2781717372/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93jJqrgJ80buzch3y4FmAur63ohF0M0h2GuEOwOps2Rl4Meta } from "/codebuild/output/src2781717372/src/src/pages/parking/[id].vue?macro=true";
import { default as indexNBCM6XTK7NHpdjRP_I1DUUbDXBk4yyuv0F7zLyNFsIMMeta } from "/codebuild/output/src2781717372/src/src/pages/history/index.vue?macro=true";
import { default as index0DSKKRFNwfK_455Hh4IYmh3zba8Tbprja_C0pPN3mpDkwMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/index.vue?macro=true";
import { default as index0zMQzDMCjXp6jTdE3feD2i1_L3w6eFo0vj_gKpcoNQAMeta } from "/codebuild/output/src2781717372/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexL77ATfConlMUPA8u1lZXiy5a8Ct1JBtQjyQK5MgFiJ0Meta } from "/codebuild/output/src2781717372/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi8xrtcRj_fwH1SmTablI0JyvTWxDlRD_18fxW_9jblKsMeta } from "/codebuild/output/src2781717372/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editV6ThEZGZjBWSjbOBJim0QSAXueqOqkd2UhMZi6clw5AMeta } from "/codebuild/output/src2781717372/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementCYaikLQu_45_45IbIUpvExfsOcFV3aEpOxnEONbzeioMq8QMeta } from "/codebuild/output/src2781717372/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexAGtjasuvMiUHBMIUsRzvoEOtnExAZXTmsBYb_45s1AWkAMeta } from "/codebuild/output/src2781717372/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dH5k07g4kjS7Aa_qfxk0crz93Q_459vw30ciapkgAJeQ8cMeta } from "/codebuild/output/src2781717372/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmEwVdunG7vcKoJlJ9Sw5_QYPNsGoYt9Rt9pu0IFwhn7MMeta } from "/codebuild/output/src2781717372/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index88k2b1IqKz2TmjUp6tH1l47Fqu8hegX_45YmJca_4500AKcMeta } from "/codebuild/output/src2781717372/src/src/pages/card/create/index.vue?macro=true";
import { default as indexd4yvOcavJRDa3sD11rMv60bS5qn_9rguZHmGoEmI7RwMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmM4gJDFrw3xqJflU1OPQwFCMZNr_lYAtcbnaS3N_U98kMeta } from "/codebuild/output/src2781717372/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm_458IVEcApPrxxgXVJf0JU4VG9Ax0rGrqvXjTACAn_45itEMeta } from "/codebuild/output/src2781717372/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeXd3P1XocfN6AfmRVdzNCqsPRr3I5Rf3r_454q6Rfx7a00Meta } from "/codebuild/output/src2781717372/src/src/pages/membership/complete.vue?macro=true";
import { default as registerFnfpkAh9wGO2nFlZP9vetwEjSVdT60QOEYyBwGdDIToMeta } from "/codebuild/output/src2781717372/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93kIC150GpwDo8OFEIeHbLBuX2KTasZqSFpBHA7RqaYcAMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmQX5B3j9hlQIW2Yo1APynC_GyTxpu4qrWp8A5SOzOkDAMeta } from "/codebuild/output/src2781717372/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93BjRbssvd_IKjJFn_45UcQp7JHGfN2N9wqwTTxjiQ5kGrAMeta } from "/codebuild/output/src2781717372/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexzjCdZaYA2y8R5V6EUENix56ztPamlfTyvrtpoOoEs60Meta } from "/codebuild/output/src2781717372/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeJrR7mtrytgPPfpwpUGolYQSKedJK4wPwojsI_45pizhkwMeta } from "/codebuild/output/src2781717372/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codej7lhU_aYt9VWdqzJVPXLPJZpwpdl76RXEvx575HasxAMeta } from "/codebuild/output/src2781717372/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeG0U4_H9z8kOTi_M3KCqm9MlBbYMOvFKNsn4dcCjDCz4Meta } from "/codebuild/output/src2781717372/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerDoGfbZOoIZt2Fo_45PjTOAVEo0RYBLgRl9Kw7BIK1KaFIMeta } from "/codebuild/output/src2781717372/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeNmM3bqR_QgYnyyc_80jnjc4lTTZxY41MhN0ma1vfCJoMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexhOW8E9KSXFruA_zHeAHcGtxe1SO9xnbTW981KmcO0ssMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmGJx7DTUD4zis_45b5h9iYKwAcw3gDT81HXqfyZnMJeelQMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeIPwil25PRQQETan4yR078kMv6BDXLT9hUe3PxXAHsokMeta } from "/codebuild/output/src2781717372/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexITiwcXCIFG4gQz1a6MHEQCuoXb2Hupcnf_45YXh0oShu0Meta } from "/codebuild/output/src2781717372/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93LAX5mWnWPVyayAVLXkf6Gz5xyTFsX9SOvOcBIZmQDiMMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeOrN7drfgerV7BN_45_Hj61R8SWiVY2ZouZqMe49tuOMeAMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasBMg2oYfX7dO52T30HDmMC3N05U5dk2OxBxVKYAqTQ_kMeta } from "/codebuild/output/src2781717372/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplexWo4UHOVO8bUGIZVE8ToyAlb_xlrIlfHB5PegHjIqPEMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailslDgFsbmR6sezxO1mXfgatboXnRRQEbdz9BYA3kF9l4Meta } from "/codebuild/output/src2781717372/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmjtmDS6WnMbcJavWk2e_QXfuJz2Whq63qGLvy6_4547BNwMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentC1z_bjUMq4CXUUww44bWEg_9Qp9qKYl8GWL17bCq0bIMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmbC3s9gauE9hzIDJwXjKF_YWI6rVdj4tSe_45seUag4HhIMeta } from "/codebuild/output/src2781717372/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateGyCFl137TWGZaAhT7VcWtMHUfOKS_4537DEZSvQK4D6KsMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeeSzI1UT_45Z_45EJAq8kFdOiZdBytDHg_45Hojg1KzAjVfy3UMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code4vInl0nLGw2VdUbfAKTKgyp2RW9ffZnQ6QwtFZTRBAwMeta } from "/codebuild/output/src2781717372/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passworddxHez5xN9RNUPiw4aTsA1Lydap7_45r45XYpfHbbgYAd4Meta } from "/codebuild/output/src2781717372/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaswiyMEalSz6leFaoeCFBBF4M1RpTA3of3Re2dmUaiLeQMeta } from "/codebuild/output/src2781717372/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register3wYbgArfry_4517UGYfwOBnJVxgD7Pz7_DyFVjMajj_10Meta } from "/codebuild/output/src2781717372/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeeW9sWH_45fGgDac_45_45oIiGwkMHoFrJj_wAMennhldr_wjIMeta } from "/codebuild/output/src2781717372/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexrJSiKrUY5fWjBuUPivjC4UCM5yzd56UDAThYTHp7gFcMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexk9R2UldhJLSOWE_dPIIh0lYw4eX7HYBqYCM3dx_4__45MMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexV456Ke5y91YazDG_45CecmuJNKes7HzrdPa2nWGlPS9bYMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexj_ZMKCcRI8Dx5hSnNl8TdwIuD_45RPADkd_q8ps1mtapwMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateIsNzqSPyNRvwB3Qlx_45enJDPOmmOnhqzegletzH79hYsMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeSKbRqtci29p8EcpvIZFnRs31UqibWvEXEWnrzl5G34cMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmD4LSGYBVbZRSguHkkAGT48kJRH9ZEaIahw99iAvS2igMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexqoincSqrUnBl3CcDexMyIICt4_SW7RMNIFLrQDzAoO8Meta } from "/codebuild/output/src2781717372/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete46IYtIxrgq29E9O9QLIQTFoZNeU_kyqmX9Wj7OpQ7WYMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateZJLDe_HuydCrwwLqtwQnMVihUl0eRd4K_vf_45N4457ZUMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexeWd4BMr_45JTtwXx0Pw3mXwyJECFj4TUT3qryWIRJ2lfMMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexxEQLGhGhV9bYxzJP4Cvnlah6dktYm1zOle1_8OMyPN8Meta } from "/codebuild/output/src2781717372/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeRelSOoC8u41_45gGCVNPxf0tYDGbgkJfG0x6nn5KN6PeQMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index7K37eD5FzJGycGeORhBJLVwj8xh7XurzIHjcSAvu3rkMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeTzBL2aCc_QHfmt_455rLgjHtFFxw6MZq0gfL_wCPAE_45IwMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexO_StzZrFIyjn2YF_452KrY5iJnVnZG96pgEO1sMjg7aZIMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index0IkpVYgbLJHO2KBrdaROmMyRUPQmxfMDcmvKrAHoNw0Meta } from "/codebuild/output/src2781717372/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexJ8olvhA9Z_45jMB8hfxrjYqlpPc28s79g5LZYq8fGYpMwMeta } from "/codebuild/output/src2781717372/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updated6mEOD6TaR75JdiAfQsHyzZ1yoBQ2f5pT3hIxfqvtaMMeta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmpHC7U31ottyy9ixqljFjRmxdxSoqHFUkZ0WYnDJv9F0Meta } from "/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menueKJ_459xPHB6JaXRjJPOoYu46lEXGuzRK8lde6jnrNxGAMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexTKhq3FpZ7KcEMu1Lsxfkx6e6OKOglfxxAuEWlwP6HvYMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexL3n4SxzwGR4pQiEUacw1PQJ270BzeQfTEsjJdU66AKEMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexNBCM6XTK7NHpdjRP_I1DUUbDXBk4yyuv0F7zLyNFsIMMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index0zMQzDMCjXp6jTdE3feD2i1_L3w6eFo0vj_gKpcoNQAMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexL77ATfConlMUPA8u1lZXiy5a8Ct1JBtQjyQK5MgFiJ0Meta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index88k2b1IqKz2TmjUp6tH1l47Fqu8hegX_45YmJca_4500AKcMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmM4gJDFrw3xqJflU1OPQwFCMZNr_lYAtcbnaS3N_U98kMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm_458IVEcApPrxxgXVJf0JU4VG9Ax0rGrqvXjTACAn_45itEMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeXd3P1XocfN6AfmRVdzNCqsPRr3I5Rf3r_454q6Rfx7a00Meta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerFnfpkAh9wGO2nFlZP9vetwEjSVdT60QOEYyBwGdDIToMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmQX5B3j9hlQIW2Yo1APynC_GyTxpu4qrWp8A5SOzOkDAMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeJrR7mtrytgPPfpwpUGolYQSKedJK4wPwojsI_45pizhkwMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codej7lhU_aYt9VWdqzJVPXLPJZpwpdl76RXEvx575HasxAMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeG0U4_H9z8kOTi_M3KCqm9MlBbYMOvFKNsn4dcCjDCz4Meta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerDoGfbZOoIZt2Fo_45PjTOAVEo0RYBLgRl9Kw7BIK1KaFIMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmGJx7DTUD4zis_45b5h9iYKwAcw3gDT81HXqfyZnMJeelQMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeIPwil25PRQQETan4yR078kMv6BDXLT9hUe3PxXAHsokMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexITiwcXCIFG4gQz1a6MHEQCuoXb2Hupcnf_45YXh0oShu0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeOrN7drfgerV7BN_45_Hj61R8SWiVY2ZouZqMe49tuOMeAMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplexWo4UHOVO8bUGIZVE8ToyAlb_xlrIlfHB5PegHjIqPEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailslDgFsbmR6sezxO1mXfgatboXnRRQEbdz9BYA3kF9l4Meta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmjtmDS6WnMbcJavWk2e_QXfuJz2Whq63qGLvy6_4547BNwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentC1z_bjUMq4CXUUww44bWEg_9Qp9qKYl8GWL17bCq0bIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmbC3s9gauE9hzIDJwXjKF_YWI6rVdj4tSe_45seUag4HhIMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeeSzI1UT_45Z_45EJAq8kFdOiZdBytDHg_45Hojg1KzAjVfy3UMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code4vInl0nLGw2VdUbfAKTKgyp2RW9ffZnQ6QwtFZTRBAwMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passworddxHez5xN9RNUPiw4aTsA1Lydap7_45r45XYpfHbbgYAd4Meta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register3wYbgArfry_4517UGYfwOBnJVxgD7Pz7_DyFVjMajj_10Meta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeeW9sWH_45fGgDac_45_45oIiGwkMHoFrJj_wAMennhldr_wjIMeta || {},
    component: () => import("/codebuild/output/src2781717372/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2781717372/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]